"use client"

import { useState, useEffect, useRef } from "react"
import "./UXProcess.css"

const UXProcess = () => {
  const [activeTab, setActiveTab] = useState("research")
  const headerRef = useRef(null)
  const textRef = useRef(null)
  const tabsRef = useRef(null)

  const tabContent = {
    research: {
      title: "RESEARCH",
      items: [
        "1. BRIEFING",
        "2. BENCHMARK",
        "3. USER RESEARCH",
      ],
      description: `Our UX designers will target the users profiles and identify their needs when using your product, considering its usefulness and effectiveness from their point of view. Research on design patterns and the industry's most used technologies allows leveraging and understand existing players' knowledge and practice. Plus, it ensures your product/design is specific and different.`,
    },
    evaluation: {
      title: "EVALUATION",
      items: [
        "1. UX ASSESMENT",
        "2. EXECUTIVE PRESENTATION",
        
      ],
      description: `We will conduct a UX review to set the product requirements considering the established usability heuristics in the field to deliver a consistent and fluid user experience. All information regarding insights and analytics will be summarised in a visual and compelling audit report that showcases the UX Audit's main findings, quick wins, and recommendations regarding your product's potential improvements.`,
    },
    execution: {
      title: "EXECUTION",
      items: [
        "1. STYLE GUIDE",
        "2. GRAPHICAL USER INTERFACE",
        
      ],
      description: `Together, we will baseline the style guide to ensure that your product's different visual interface elements' are consistent and coherent. Running a UX Audit allows us to solve the main encountered problems with the execution of end-looking screens. Plus, all recommendations that resulted from quick wins acknowledgement will be designed for implementation.`,
    },
  }

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("visible")
      })
    }, { threshold: 0.1 })

    const elements = [headerRef.current, textRef.current, tabsRef.current]
    elements.forEach((el) => el && observer.observe(el))

    return () => elements.forEach((el) => el && observer.unobserve(el))
  }, [])

  return (
    <div className="container" id="process">
      <div className="container">
    <div className="ux-container">
      <div className="ux-wrapper">
        <div className="header-section" ref={headerRef}>
          <h2 className="header-title">
            OUR
            <br />
            <span className="highlight">UX AUDIT</span>
            <br />
            <span className="highlight">PROCESS</span>
          </h2>
          
        </div>

        {/* Tabs */}
        <div className="tabs-container" ref={tabsRef}>
          <div className="tabs-header">
            <button className={`tab-button ${activeTab === "research" ? "active" : ""}`} onClick={() => setActiveTab("research")}>
              <div className="tab-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 20h20M5 20V8.5M9 20v-9M13 20v-5.5M17 20v-9"/></svg>
              </div>
              RESEARCH
            </button>
            <button className={`tab-button ${activeTab === "evaluation" ? "active" : ""}`} onClick={() => setActiveTab("evaluation")}>
              <div className="tab-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
              </div>
              EVALUATION
            </button>
            <button className={`tab-button ${activeTab === "execution" ? "active" : ""}`} onClick={() => setActiveTab("execution")}>
              <div className="tab-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3h18v18H3z"/><path d="M8 6h8M8 10h8M8 14h8M8 18h8"/></svg>
              </div>
              EXECUTION
            </button>
          </div>

          <div className="tab-content">
            {Object.entries(tabContent).map(([key, tab]) => (
              <div key={key} className={`tab-panel ${activeTab === key ? "active" : ""}`}>
                <h3 className="tab-title">{tab.title}</h3>
                <ul className="tab-list">
                  {tab.items.map((item, idx) => <li key={idx} className="tab-item">{item}</li>)}
                </ul>
                <p className="tab-description">{tab.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="cta-section">
          <h3 className="cta-title">NEED A QUOTE FOR YOUR PROJECT?</h3>
          <p className="cta-description">
            Our team of business developers and project managers can help you to clarify any questions you have related.
            Feel free to chat with us anytime and get a quote for your project.
          </p>
          <button className="quote-button">GET A QUOTE</button>
        </div>
      </div>
    </div>
    </div>
    </div>
  )
}

export default UXProcess
